<template>
  <!-- 专属装备数据 -->
  <div class="exclusive-equipment">
    <div class="bar">
      <div class="left">
        <img class="icon" alt="" :src="dataSource.icon.value" />
        <div class="name">专属装备：{{ dataSource.name.value }}</div>
        <div class="type">[{{ dataSource.equipType.value }}]</div>
      </div>
    </div>
    <div class="data">
      <div class="item">
        <span class="label">{{ dataSource.attr0.label.value }}:</span>
        <span class="value">{{ dataSource.attr0.desc.value }}</span>
      </div>
      <div class="item">
        <span class="label">{{ dataSource.attr1.label.value }}:</span>
        <span class="value">{{ dataSource.attr1.desc.value }}</span>
      </div>
      <div class="item">
        <span class="label">{{ dataSource.attr2.label.value }}:</span>
        <span class="value">{{ dataSource.attr2.desc.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
};
</script>

<style lang="less" scoped>
.exclusive-equipment {
  width: 100%;
  margin-bottom: 38px;
  .bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    .left {
      display: flex;
      align-items: center;
    }

    .icon {
      width: 30px;
      height: 30px;
      border-radius: 2px;
      border: 1px solid #627b7c;
      margin-right: 12px;
    }

    .name {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
    }

    .type {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #ff8787;
      margin-left: 11px;
    }
  }
  .data {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .item {
      display: flex;
      flex-direction: column;
      gap: 13px;

      .label {
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 15px;
        color: #ffffff;
      }

      .value {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 15px;
        color: #ffffff;
      }
    }
  }
}
</style>
